import { render, staticRenderFns } from "./UserProfile.vue?vue&type=template&id=607a3e79&scoped=true"
import script from "./UserProfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserProfile.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UserProfile.vue?vue&type=style&index=0&id=607a3e79&prod&scoped=true&lang=scss"
import style1 from "./UserProfile.vue?vue&type=style&index=1&id=607a3e79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607a3e79",
  null
  
)

export default component.exports